 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"patch-notes-ca":"patch-notes-ca","patch-notes-de":"patch-notes-de","patch-notes-en":"patch-notes-en","patch-notes-fr":"patch-notes-fr"}[chunkId]||chunkId) + ".v.7.3.0.1762184266029.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-00f2572a":1,"chunk-09df8744":1,"chunk-3cbd6664":1,"chunk-0c38693b":1,"chunk-14a7b6da":1,"chunk-15cf5f79":1,"chunk-1d7bcf8f":1,"chunk-1eeac770":1,"chunk-21f8bffc":1,"chunk-239aa57a":1,"chunk-24ecb284":1,"chunk-27990389":1,"chunk-2859d118":1,"chunk-291351b4":1,"chunk-2931b7f3":1,"chunk-2dce704e":1,"chunk-2ddc06ae":1,"chunk-3501798e":1,"chunk-44ff9bfa":1,"chunk-6bee6494":1,"chunk-062c203b":1,"chunk-1c82b229":1,"chunk-26304748":1,"chunk-0546a300":1,"chunk-f3b4ea82":1,"chunk-4a6b325f":1,"chunk-8f76e7f0":1,"chunk-558bbdfc":1,"chunk-562b7cd9":1,"chunk-6cb463f0":1,"chunk-d5ad2746":1,"chunk-566bed53":1,"chunk-56d5da4c":1,"chunk-5d139fdc":1,"chunk-5efba337":1,"chunk-6b8c0f6f":1,"chunk-7ac734aa":1,"chunk-8124918c":1,"chunk-84fb91ee":1,"chunk-b2d3ac5a":1,"chunk-b6b5fa52":1,"chunk-b8150240":1,"chunk-0d64b020":1,"chunk-d3493dbe":1,"chunk-cca46a30":1,"chunk-fd100318":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"patch-notes-ca":"patch-notes-ca","patch-notes-de":"patch-notes-de","patch-notes-en":"patch-notes-en","patch-notes-fr":"patch-notes-fr"}[chunkId]||chunkId) + "." + {"chunk-00f2572a":"2ed43070","chunk-047ad542":"31d6cfe0","chunk-09df8744":"a6b90016","chunk-3cbd6664":"28a9cd07","chunk-0c38693b":"510cb629","chunk-14a7b6da":"a2124fc4","chunk-15cf5f79":"0050f2f1","chunk-1d7bcf8f":"13d6dd07","chunk-1eeac770":"021bce2e","chunk-21f8bffc":"3be3e727","chunk-239aa57a":"e1cc78c2","chunk-24ecb284":"06496ec8","chunk-27990389":"4291ca86","chunk-2859d118":"069f3154","chunk-291351b4":"ecf6ccaf","chunk-2931b7f3":"8bd40b7e","chunk-2af834ee":"31d6cfe0","chunk-2d0afa4b":"31d6cfe0","chunk-2d0b8a33":"31d6cfe0","chunk-2d0baa6b":"31d6cfe0","chunk-2d221bba":"31d6cfe0","chunk-2dce704e":"0010242b","chunk-2ddc06ae":"9cff56ea","chunk-2e8971e9":"31d6cfe0","chunk-3501798e":"3b53c626","chunk-44ff9bfa":"7e0aa530","chunk-6bee6494":"82eed988","chunk-062c203b":"ca673d2a","chunk-065b4fe9":"31d6cfe0","chunk-0895e215":"31d6cfe0","chunk-0bd7c8c8":"31d6cfe0","chunk-0c3eb2be":"31d6cfe0","chunk-1c82b229":"8b42f54c","chunk-212a88cc":"31d6cfe0","chunk-26304748":"1a2a872b","chunk-0546a300":"d46ff43c","chunk-327c12b1":"31d6cfe0","chunk-35454376":"31d6cfe0","chunk-358feff4":"31d6cfe0","chunk-365be2d3":"31d6cfe0","chunk-3e125f43":"31d6cfe0","chunk-4b7a4fea":"31d6cfe0","chunk-4ff7836e":"31d6cfe0","chunk-521d8201":"31d6cfe0","chunk-08066384":"31d6cfe0","chunk-0a2c3cb0":"31d6cfe0","chunk-0b79b891":"31d6cfe0","chunk-0da7c146":"31d6cfe0","chunk-1fd904f8":"31d6cfe0","chunk-248c1800":"31d6cfe0","chunk-2632a1aa":"31d6cfe0","chunk-2bd8d0a1":"31d6cfe0","chunk-2d2378a9":"31d6cfe0","chunk-37a9b8e2":"31d6cfe0","chunk-397313b4":"31d6cfe0","chunk-3ed5240c":"31d6cfe0","chunk-48a4cca1":"31d6cfe0","chunk-4b16913e":"31d6cfe0","chunk-4ce3aa9d":"31d6cfe0","chunk-4f7e08ce":"31d6cfe0","chunk-56e570ef":"31d6cfe0","chunk-5a829e20":"31d6cfe0","chunk-63335f14":"31d6cfe0","chunk-3c46b911":"31d6cfe0","chunk-64605a26":"31d6cfe0","chunk-6c44c98a":"31d6cfe0","chunk-7642c36b":"31d6cfe0","chunk-8698baf4":"31d6cfe0","chunk-91c00810":"31d6cfe0","chunk-c26412ce":"31d6cfe0","chunk-d0bb1644":"31d6cfe0","chunk-e5c9e832":"31d6cfe0","chunk-fe9247c8":"31d6cfe0","chunk-56274699":"31d6cfe0","chunk-57019d53":"31d6cfe0","chunk-62f14676":"31d6cfe0","chunk-0fe8d006":"31d6cfe0","chunk-6695a748":"31d6cfe0","chunk-770f793e":"31d6cfe0","chunk-78112050":"31d6cfe0","chunk-7874b135":"31d6cfe0","chunk-7f0db542":"31d6cfe0","chunk-97da85b4":"31d6cfe0","chunk-47db5b0a":"31d6cfe0","chunk-526c4a36":"31d6cfe0","chunk-5c42e83d":"31d6cfe0","chunk-640bb160":"31d6cfe0","chunk-6745bcfe":"31d6cfe0","chunk-91f1ae24":"31d6cfe0","chunk-a4d835b2":"31d6cfe0","chunk-d9667660":"31d6cfe0","chunk-e819a30e":"31d6cfe0","chunk-a50c8066":"31d6cfe0","chunk-b243267a":"31d6cfe0","chunk-bfe1c792":"31d6cfe0","chunk-c4155390":"31d6cfe0","chunk-ed096132":"31d6cfe0","chunk-f289cda2":"31d6cfe0","chunk-f3b4ea82":"5640a2b9","chunk-281cca88":"31d6cfe0","chunk-4332fe40":"31d6cfe0","chunk-afc207ec":"31d6cfe0","chunk-4a6b325f":"901df571","chunk-8f76e7f0":"0d8a77ab","chunk-558bbdfc":"cd73b593","chunk-562b7cd9":"a376c4bb","chunk-6cb463f0":"8c0cbc8e","chunk-d5ad2746":"b5c34506","chunk-566bed53":"03ce700d","chunk-56d5da4c":"f0b3667b","chunk-5d139fdc":"5368b978","chunk-5efba337":"7dc29c8e","chunk-6b8c0f6f":"8bb71072","chunk-7110de74":"31d6cfe0","chunk-7ac734aa":"6c6cb5d8","chunk-7d579b14":"31d6cfe0","chunk-20d7fec3":"31d6cfe0","chunk-ddce5642":"31d6cfe0","chunk-8124918c":"b3f20e6c","chunk-84fb91ee":"63a9fc1d","chunk-b2d3ac5a":"68c9997d","chunk-b6b5fa52":"8a84604b","chunk-b8150240":"e57d7db4","chunk-b8b9ae5e":"31d6cfe0","chunk-0d64b020":"c4b27212","chunk-d3493dbe":"0e6bd337","chunk-c60278ce":"31d6cfe0","chunk-cca46a30":"8c255b77","chunk-cf9b4218":"31d6cfe0","chunk-fd100318":"85bc3c9a","patch-notes-ca":"31d6cfe0","patch-notes-de":"31d6cfe0","patch-notes-en":"31d6cfe0","patch-notes-fr":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
